
<div class="row">
    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
            <span class="info-box-icon bg-green">
                {{ objDashboard.ActiveCustomer }}
            </span>

            <div class="info-box-content">
                <span class="info-box-text">Registered</span>
                <span class="info-box-text">Customer</span>
            </div>
        </div>
    </div>

    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
            <span class="info-box-icon bg-blue-gradient">
                {{ objDashboard.ActiveBooth }}
            </span>

            <div class="info-box-content">
                <span class="info-box-text">Total ATMs</span>
                <span class="info-box-text">Deployed</span>
            </div>
        </div>

    </div>


    <div class="clearfix visible-sm-block"></div>

    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
            <span class="info-box-icon bg-aqua-gradient line-2">
                {{ objDashboard.TodayWaterDispense.TodayWaterDispense }}
            </span>
            <span class="info-box-liter">Liter</span>

            <div class="info-box-content">
                <span class="info-box-text"> Today </span>
                <span class="info-box-text"> Dispense </span>
            </div>
        </div>

    </div>

    <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
            <span class="info-box-icon bg-yellow line-2">
                {{ objDashboard.MonthlyWaterDispense.MonthlyWaterDispense }}
            </span>
            <span class="info-box-liter">Liter</span>

            <div class="info-box-content">
                <span class="info-box-text"> Total </span>
                <span class="info-box-text"> Dispense </span>
            </div>
        </div>
    </div>

</div>

<div class="row">
    <div class="col-sm-12 col-xs-12">
        <app-withdraw-report-normal
        [withdrawreports]="objDashboard.LstWaterTransaction"
        title="Latest Withdraw Report">
        </app-withdraw-report-normal>
    </div>

    <!-- <div class="col-sm-3 col-xs-12">
        <app-booth-table
        [boothData]="objDashboard.LstPump"
        title="Pump Location">
        </app-booth-table>
    </div> -->
</div>

<div class="row">
    <div class="col-sm-12 col-xs-12">
        <app-customer-count-view
        [CustomerCounts]="objDashboard.NewAccountCountByMonth">
        </app-customer-count-view>
    </div>
</div>

<div class="row">

    <div class="col-sm-6 col-xs-12">
        <app-monthly-recharge
        [data]="objDashboard.RechargeSumByMonth">
    </app-monthly-recharge>
    </div>

    <div class="col-sm-6 col-xs-12">
        <app-monthly-water-dispense
        [data]="objDashboard.WaterDispenseSumByMonth">
        </app-monthly-water-dispense>
    </div>

</div>

<div *ngIf="objDashboard.LstPump">

    <app-map-pump-marker [LstPumps]="objDashboard.LstPump"></app-map-pump-marker>
</div>
